import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Trash2, FileText } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import api, { resolveMedia } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

export default function AdminBlog() {
  const [items, setItems] = useState([]);
  const { toast } = useToast();
  const load = () => api.get('/admin/blog').then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm('Delete this post?')) return;
    await api.delete('/admin/blog/' + id);
    toast({ title: 'Deleted' });
    load();
  };
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold text-neutral-900">Blog Posts</h1><p className="text-sm text-neutral-500">{items.length} articles</p></div>
        <Link to="/admin/blog/new"><Button className="btn-primary gap-2"><Plus className="w-4 h-4" /> New Post</Button></Link>
      </div>
      {items.length === 0 ? (
        <div className="bg-white p-12 rounded-xl border border-neutral-200 text-center">
          <FileText className="w-10 h-10 text-neutral-300 mx-auto mb-2" />
          <p className="text-neutral-500">No posts yet</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-neutral-50 text-neutral-600"><tr>
              <th className="text-left px-4 py-3 font-semibold">Post</th>
              <th className="text-left px-4 py-3 font-semibold">Category</th>
              <th className="text-left px-4 py-3 font-semibold">Date</th>
              <th className="text-left px-4 py-3 font-semibold">Status</th>
              <th className="text-right px-4 py-3 font-semibold">Actions</th>
            </tr></thead>
            <tbody className="divide-y divide-neutral-100">
              {items.map((p) => (
                <tr key={p.id} className="hover:bg-neutral-50">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <img src={resolveMedia(p.cover) || '/assets/logo.png'} alt={p.title} className="w-14 h-10 rounded object-cover bg-neutral-100" />
                      <div>
                        <p className="font-medium text-neutral-900 line-clamp-1">{p.title}</p>
                        <p className="text-xs text-neutral-500">by {p.author || '—'}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">{p.category}</td>
                  <td className="px-4 py-3 text-neutral-500">{p.date}</td>
                  <td className="px-4 py-3">{p.published === false ? <Badge variant="secondary">Draft</Badge> : <Badge className="bg-green-600 text-white">Published</Badge>}</td>
                  <td className="px-4 py-3 text-right">
                    <div className="inline-flex gap-1">
                      <Link to={'/admin/blog/' + p.id}><Button size="sm" variant="outline"><Edit className="w-3.5 h-3.5" /></Button></Link>
                      <Button size="sm" variant="outline" onClick={() => remove(p.id)} className="text-red-600 border-red-200"><Trash2 className="w-3.5 h-3.5" /></Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
